import { getApiError, hasValidationError } from "@/pages/security/invite.helpers.ts";
import { ApiTimeEntry } from "@/types/time-tracking.types.ts";
import { Button, Modal, ModalProps, Stack, Textarea, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ClockCommentModalProps extends ModalProps {
  mode: "in" | "out";
  onConfirm: (comment: string | null) => Promise<ApiTimeEntry>;
}

export const ClockCommentModal = ({ mode, onConfirm, ...props }: ClockCommentModalProps) => {
  const { close } = useModals();
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm(comment.trim() || null);
      close(props.id);
    } catch (error) {
      const apiError = getApiError(error);
      if (
        hasValidationError(apiError, "clocking_no_active_clock_in") ||
        hasValidationError(apiError, "clocking_already_clocked_in")
      ) {
        close(props.id);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      title={mode === "in" ? t("clocking:clock_in") : t("clocking:clock_out")}
      closeByEscEnabled={true}
      withCloser={true}
      actions={
        <Stack gap={"md"}>
          <Button size={"lg"} onClick={handleConfirm} isLoading={isLoading}>
            {mode === "in" ? t("clocking:clock_in") : t("clocking:clock_out")}
          </Button>
        </Stack>
      }
    >
      <Stack gap={"md"}>
        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          label={t("clocking:comment_placeholder")}
        />
      </Stack>
    </Modal>
  );
};
